import { api } from '../../../services/api/apiClient';
import { crudService } from '../../../services/api/crudService';
import type { ApiResponse } from '../../../types/api';
import type { ExpandedTemplate, QuoteTemplate, TemplateInput } from '../types/templateTypes';

export const templateService = {
  ...crudService<QuoteTemplate, TemplateInput>('/templates'),
  /** Lines with current rates, to copy into a quotation. */
  expand: (id: string) => api.get<ApiResponse<ExpandedTemplate>>(`/templates/${id}/expand`).then((r) => r.data),
};
